import { render } from "./SocialBox.vue?vue&type=template&id=7e290e53"
import script from "./SocialBox.vue?vue&type=script&lang=js"
export * from "./SocialBox.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__